export const VALID_EMAIL_REGEX = /[^\s@]+@[^\s@]+\.[^\s@]+/;